module.exports = __webpack_public_path__ + "images/558b629e7a86e8d87a6291f443c217c0.edit2.png";